import apiClient from "./apiClient";

export const getPrivacyPolicy = async () => {
  const websiteId = localStorage.getItem("website_id");
  try {
    const response = await apiClient.get("/get_privacy_policy", {
      headers: {
        website_id: websiteId,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching privacy policy:", error);
    throw error;
  }
};

export const getPrivacyPolicyId = async (privacyId) => {
  const websiteId = localStorage.getItem("website_id");
  try {
    const response = await apiClient.get(`/get_privacy_policy/${privacyId}`, {
      headers: {
        website_id: websiteId,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching privacy policy:", error);
    throw error;
  }
};

export const deletePrivacyPolicy = async (privacyId) => {
  const websiteId = localStorage.getItem("website_id");
  try {
    const response = await apiClient.delete(
      `/delete_privacy_policy/${privacyId}`,
      {
        headers: {
          website_id: websiteId,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching privacy policy:", error);
    throw error;
  }
};

export const generatePrivacyPolicy = async (data, accountHashid) => {
  const websiteId = localStorage.getItem("website_id");
  try {
    const response = await apiClient.post("/generate_privacy_policy/", data, {
      headers: {
        website_id: websiteId,
        account_hashid: accountHashid,
      },
    });
    return response.data; // Return the API response
  } catch (error) {
    throw error;
  }
};

export const updatePrivacyPolicy = async (privacyId, data) => {
  const websiteId = localStorage.getItem("website_id");
  try {
    const response = await apiClient.put(
      `/update_privacy_policy/${privacyId}`,
      data,
      {
        headers: {
          website_id: websiteId,
        },
      }
    );
    return response.data; // Return the API response
  } catch (error) {
    throw error;
  }
};
